module.exports = __webpack_public_path__ + "static/media/ig-icon.12dbbc9a.svg";